module.exports = __webpack_public_path__ + "img/page1-img1.968c83bd.png";